
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"22","viewBox":"0 0 20 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.534 18.6h4.4a2.751 2.751 0 11-4.4 0zM7.99 4.534A6.592 6.592 0 019.736 4.3c.604 0 1.189.081 1.745.234.293-.373.455-.832.455-1.334 0-1.21-.99-2.2-2.2-2.2-1.21 0-2.2.99-2.2 2.2 0 .502.163.961.456 1.334z","stroke":"#221B38","stroke-width":"1.5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M3.134 14.2l-2.2 4.4h17.6l-2.2-4.4v-3.3c0-3.64-2.96-6.6-6.6-6.6a6.605 6.605 0 00-6.6 6.6v3.3z","stroke":"#221B38","stroke-width":"1.5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    